import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { FlexRow } from "../flex-row";

function PageBadge({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <Badge
      className={cn(
        "border-primary text-primary px-4 py-2 font-black",
        className,
      )}
      variant="outline"
    >
      {children}
    </Badge>
  );
}

function PageGroup({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <div className={className}>{children}</div>;
}

function PageGroupHeader({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <FlexRow className={cn("mb-4", className)}>{children}</FlexRow>;
}

function PageGroupTitle({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <h2 className={cn("text-lg font-semibold text-gray-900", className)}>
      {children}
    </h2>
  );
}

function PageHeader({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <div className={className}>{children}</div>;
}

function PageSubtitle({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <p className={cn("mt-2 text-gray-600", className)}>{children}</p>;
}

function PageTitle({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <h1 className={cn("text-3xl font-bold text-gray-900", className)}>
      {children}
    </h1>
  );
}

export {
  PageBadge,
  PageGroup,
  PageGroupHeader,
  PageGroupTitle,
  PageHeader,
  PageSubtitle,
  PageTitle,
};
